/**
 * @generated SignedSource<<c515028f6384f1a591456be61a5e5cb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddOrRemoveAssignmentPrintTypeToProductsInput = {
  modelSidesToAssignsDto?: ReadonlyArray<AddOrRemoveAssignmentPrintTypeToProductsModelSidesToAssignInput | null> | null;
  printTypeID: string;
  productIDsToRemove?: ReadonlyArray<string | null> | null;
};
export type AddOrRemoveAssignmentPrintTypeToProductsModelSidesToAssignInput = {
  modelID: string;
  sides: ReadonlyArray<PrintTypeModelSideInput | null>;
};
export type PrintTypeModelSideInput = {
  colorID: string;
  sideID: string;
};
export type productSidePanelContent_UnassignPrintMethodMutation$variables = {
  input: AddOrRemoveAssignmentPrintTypeToProductsInput;
};
export type productSidePanelContent_UnassignPrintMethodMutation$data = {
  readonly addOrRemoveAssignmentPrintTypeToProducts: boolean;
};
export type productSidePanelContent_UnassignPrintMethodMutation = {
  response: productSidePanelContent_UnassignPrintMethodMutation$data;
  variables: productSidePanelContent_UnassignPrintMethodMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "addOrRemoveAssignmentPrintTypeToProducts",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_UnassignPrintMethodMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_UnassignPrintMethodMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "27bed3bf43b913301431fb4d6900be10",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_UnassignPrintMethodMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_UnassignPrintMethodMutation(\n  $input: AddOrRemoveAssignmentPrintTypeToProductsInput!\n) {\n  addOrRemoveAssignmentPrintTypeToProducts(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "b0281c0d4561efaac5b9a1e6918bcc85";

export default node;
